import { PATH_LIST } from "shared/lib/react-router";
import "./style.scss";
import "react-datepicker/dist/react-datepicker.css";
import { BirthdayForm } from "widgets/auth/forms";
import { useTranslation } from "react-i18next";
import { KYC_Step } from "entities/account";
import moment from "moment";
import { useVerificationStep } from "hooks/useVerificationStep";

export const DateOfBirthPage = () => {
  const { t } = useTranslation("onboarding");

  const { kyc, isLoading, onSubmit } =
    useVerificationStep<KYC_Step.DateOfBirth>({
      step: KYC_Step.DateOfBirth,
      navigateOnSuccess: PATH_LIST.residenceAddress,
    });

  return (
    <div className="date-of-birth">
      <p className="register-title">{t("dateOfBirth")}</p>

      <BirthdayForm
        initialValues={
          kyc?.birth_date
            ? {
                day: moment(kyc.birth_date, "YYYY-MM-DD").get("date"),
                month: moment(kyc.birth_date, "YYYY-MM-DD").get("month") + 1,
                year: moment(kyc.birth_date, "YYYY-MM-DD").get("year"),
              }
            : { day: "", month: "", year: "" }
        }
        disabled={isLoading}
        onClick={(birth_date: string) => {
          onSubmit({ birth_date });
        }}
      />

      <div></div>
    </div>
  );
};
